<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <div v-if="!loading">
        <app-okr-instruction class="mb-8" :active.sync="instructionVisible" />
      </div>
      <app-objectives :quarter="currentQuarter" />
    </div>
  </div>
</template>

<script>
import AppObjectives from '../components/app-objective/AppObjectives.vue'
import AppOKRInstruction from '../components/AppOKRInstruction.vue'
export default {
  computed: {
    loading() {
      return this.$store.state.okrs.loading
    },
    currentQuarter() {
      return this.$store.getters['okrs/currentQuarter']
    },
    instructionVisible: {
      get() {
        return this.$store.state.okrs.instructionVisible
      },
      set(value) {
        this.$store.dispatch('okrs/changeInstructionVisible', value)
        this.$emit('setActions', [
          {
            title: this.$t('MyOKRs.ToggleInstructionAction'),
            icon: 'HelpCircleIcon',
            action: () => {
              this.instructionVisible = !this.instructionVisible
            }
          }
        ])
      }
    }
  },
  mounted() {
    this.$emit(
      'changeRouteTitle',
      this.$t('MainMenu.MyOKRs', {
        quarter: `Q${this.$store.getters['okrs/currentQuarter'].quarter}`
      })
    )
    this.$emit('setActions', [
      {
        title: this.$t('MyOKRs.ToggleInstructionAction'),
        icon: 'HelpCircleIcon',
        action: () => {
          this.instructionVisible = !this.instructionVisible
        }
      }
    ])
  },
  components: {
    AppObjectives,
    'app-okr-instruction': AppOKRInstruction
  }
}
</script>
